import { render } from "./ThePassUpper.vue?vue&type=template&id=2fe62d22&scoped=true"
import script from "./ThePassUpper.vue?vue&type=script&lang=js"
export * from "./ThePassUpper.vue?vue&type=script&lang=js"

import "./ThePassUpper.vue?vue&type=style&index=0&id=2fe62d22&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2fe62d22"

export default script